
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The primary position profile for this candidate profile.`}</p>
    <p>{`This is a convenience field to avoid an extra hop through `}<inlineCode parentName="p">{`associatedPositionOpenings`}</inlineCode>{`.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`For candidate applications, this is the job ad that the candidate applied to.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`For purchased profiles, this is the unposted position profile that the purchase is scoped to.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`For uploaded candidate profiles, this is always `}<inlineCode parentName="p">{`null`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`For Apply with SEEK candidate profiles, this is always `}<inlineCode parentName="p">{`null`}</inlineCode>{`.`}</p>
      </li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;